<template>
  <div>
    <h5 class="mb-3">MEDPadala Balance:</h5>
    <h2
      class="text-primary"
      :style="{
        color:
          webDesign && webDesign.design
            ? `${webDesign.design.main_color} !important`
            : null
      }"
    >
      Php {{ medPadalaData.balance | twoDecimalPlaces }}
    </h2>
    <p class="text-muted">
      As of {{ medPadalaData.milliseconds_date | moment("MMMM D, YYYY") }}
    </p>
    <div class="py-3">
      <b-button
        block
        pill
        class="py-2 bg-transparent border-0 text-uppercase text-muted shadow-none"
        v-if="medPadalaData.balance === 0"
        @click="medPadalaStep = 1"
      >
        Back
      </b-button>
      <b-button
        v-else
        variant="primary"
        block
        pill
        class="border-0 py-2 text-uppercase"
        :style="{
          backgroundColor:
            webDesign && webDesign.design
              ? `${webDesign.design.main_color} !important`
              : null,
          color:
            webDesign && webDesign.design
              ? `${webDesign.design.button_text_color} !important`
              : null
        }"
        @click="medPadalaStep = 3"
      >
        Next
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { Decimal } from "decimal.js";
import moment from "vue-moment";

export default {
  name: "MEDPadalaBalance",
  data() {
    return {
      moment
    };
  },
  computed: {
    ...mapState("estore", {
      webDesign: state => state.webDesign
    }),
    ...mapGetters("medpadala", ["medPadalaData"]),
    ...mapFields("medpadala", ["medPadalaStep"])
  },
  filters: {
    twoDecimalPlaces: function(value = null) {
      if (value != null) {
        var re = new RegExp("^-?\\d+(?:.\\d{0," + (2 || -1) + "})?");
        var sNumber = Number(value.toString().match(re)[0]);
        let twoDecimalPlaces = new Decimal(sNumber);
        return Number(twoDecimalPlaces).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    }
  }
};
</script>
